import { Component, OnInit, Inject } from '@angular/core';
import { PollinationReportFormGroup } from './pollination-report-form-group';
import { FormControl } from '@angular/forms';
import { Crop } from '../../shared/services/crop.service';
import { REPORTING_FILTER_OPTIONS, ReportingFilterOptions } from '../services/reporting-filter-options.service';
import { LoadingWrapperService } from '../../shared/services/loading-wrapper.service';
import { AlertService } from '../../shared/services/alert.service';
import { ReportingService } from '../services/reporting.service';
import { FileSaverService } from '../../shared/services/file-saver.service';
import { AlphabeticalNamedSorter } from '../../shared/sort-methods';
import { finalize } from 'rxjs/operators';

@Component({
  selector: 'app-pollination-report-form',
  templateUrl: './pollination-report-form.component.html'
})
export class PollinationReportFormComponent implements OnInit {
  public rootForm: PollinationReportFormGroup;

  public get startDateFormControl(): FormControl {
    return this.rootForm.startDateFormControl;
  }

  public get endDateFormControl(): FormControl {
    return this.rootForm.endDateFormControl;
  }

  public get cropFormControl(): FormControl {
    return this.rootForm.cropFormControl;
  }

  public crops: Crop[] = [];

  constructor(@Inject(REPORTING_FILTER_OPTIONS) options: ReportingFilterOptions,
    private loadingService: LoadingWrapperService,
    private alertService: AlertService,
    private reportingService: ReportingService,
    private reportWriterService: FileSaverService) { 
    this.rootForm = new PollinationReportFormGroup();
    options.crops.subscribe(c => this.crops = c.sort(AlphabeticalNamedSorter));
  }

  ngOnInit() {
  }

  public generateReport(): void {
    this.loadingService.setMessage('Generating pollination report...');

    this.reportingService.getPollinationReport({
      cropId: this.cropFormControl.value,
      endDate: this.endDateFormControl.value,
      startDate: this.startDateFormControl.value
    })
    .pipe(finalize(() => this.loadingService.clearMessage()))
    .subscribe(
      file => this.reportWriterService.save(file),
      error => this.alertService.error('Error generating pollination report.'));
  }
}


// WEBPACK FOOTER //
// F:/PHAZP5152IS01-2/_work/98/s/src/app/reporting/pollination-report-form/pollination-report-form.component.ts